var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPurchaseHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 591,
    height: 504,
    viewBox: "0 0 591 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Wallet is Empty",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M272.499 73.4004C211.962 78.5249 189.713 129.765 207.94 159.633C220.801 180.707 242.595 209.188 283.221 202.356C323.844 195.523 327.267 157.926 305.872 152.812C284.478 147.7 208.258 171.551 216.872 226.651C223.09 266.407 276.987 277.866 276.987 277.866",
    stroke: "#DCDCE2",
    strokeWidth: 1.16505,
    strokeDasharray: 4.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.485 41.9417C307.485 41.9417 316.159 19.282 317.073 10.4671C317.554 5.86105 309.921 -6.96321 300.988 4.89923C292.055 16.7617 296.13 31.3065 307.485 41.9417Z",
    fill: "#DCDCE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.706 17.2621C266.544 13.8256 261.943 16.505 259.983 21.8531C258.022 27.203 260.76 37.3861 276.087 39.7075C291.415 42.0288 306.611 41.9397 306.611 41.9397C306.611 41.9397 286.868 20.6987 276.706 17.2621Z",
    fill: "#DCDCE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.767 46.4298C305.997 45.4826 306.303 44.5748 306.642 43.6875C304.766 43.9838 302.857 44.4001 300.936 44.9636C298.852 45.5734 296.907 46.3733 295.077 47.2897C294.283 48.7901 293.64 50.3934 293.222 52.1148C290.647 62.7123 296.726 73.3937 306.941 76.8914C308.047 76.6721 309.158 76.4186 310.271 76.0932C313.382 75.1819 316.252 73.9761 318.845 72.5784C308.87 68.202 303.13 57.2808 305.767 46.4298Z",
    fill: "#DCDCE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.18 51.9579C291.424 50.9109 291.755 49.9098 292.122 48.9316C283.285 54.5928 278.336 63.3789 279.152 68.5025C273.506 70.9295 269.909 72.974 269.909 72.974C269.909 72.974 274.17 72.6497 280.378 71.4564C283.703 76.3157 292.921 79.5693 303.113 78.4025C293.88 73.6279 288.669 62.762 291.18 51.9579Z",
    fill: "#DCDCE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.171 56.0466C317.987 55.5204 316.632 53.3179 317.158 51.112C317.682 48.9213 319.89 47.5637 322.072 48.0898C324.267 48.6194 325.607 50.8303 325.085 53.0228C324.557 55.227 322.366 56.5745 320.171 56.0466ZM309.964 43.9112C309.529 44.9223 309.159 45.9889 308.895 47.0937C306.578 56.7792 311.929 66.5218 321.004 69.9011C328.576 65.1695 332.828 58.4696 331.103 52.6523C329.185 46.127 320.367 42.7572 309.964 43.9112Z",
    fill: "#DCDCE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.405 504H420.245C427.06 504 432.588 498.459 432.588 491.626V311.309C432.588 304.459 427.047 298.907 420.217 298.907H144.882C141.622 298.907 138.981 301.554 138.981 304.822V491.546C138.981 498.424 144.542 504 151.405 504Z",
    fill: "#F1F2F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.24 501.841H183.863C184.113 501.841 184.318 501.636 184.318 501.385V273.456C184.318 273.204 184.113 273 183.863 273H151.24C144.468 273 138.981 278.47 138.981 285.222V489.619C138.981 496.368 144.468 501.841 151.24 501.841Z",
    fill: "#BEC0D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.992 426.282H449.407C449.656 426.282 449.86 426.076 449.86 425.821V374.931C449.86 374.676 449.656 374.469 449.407 374.469H364.992C358.211 374.469 352.711 380.036 352.711 386.899V413.853C352.711 420.718 358.211 426.282 364.992 426.282Z",
    fill: "url(#paint0_linear_205_13283)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.569 273H151.535V273.03C144.579 273.198 138.981 278.905 138.981 285.954C138.981 293.004 144.579 298.711 151.535 298.878V298.906H397.588C397.841 298.906 398.046 298.702 398.046 298.447V287.585C398.046 279.529 391.563 273 383.569 273Z",
    fill: "#D8DBEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.729 400.376C393.729 406.338 388.897 411.171 382.935 411.171C376.973 411.171 372.141 406.338 372.141 400.376C372.141 394.414 376.973 389.582 382.935 389.582C388.897 389.582 393.729 394.414 393.729 400.376Z",
    fill: "#FEFEFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 25",
    d: "M20.0068 325.049V330.292",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 27",
    d: "M9.52441 330.293L13.0196 333.788",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    d: "M4.28027 340.775H9.52299",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 31",
    d: "M9.52441 351.261L13.0196 347.766",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 33",
    d: "M20.0068 356.506V351.264",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 35",
    d: "M30.4922 351.261L26.9971 347.766",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 37",
    d: "M35.7378 340.775H30.4951",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 39",
    d: "M30.4922 330.293L26.9971 333.788",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 41",
    d: "M289.134 110.098V113.593",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 43",
    d: "M280.397 118.834H283.893",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 45",
    d: "M289.134 129.319V125.824",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 47",
    d: "M299.619 120.58H296.124",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 49",
    d: "M96.8994 248.156V253.399",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 51",
    d: "M81.1729 263.883H86.4156",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 53",
    d: "M95.1533 277.862V272.619",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 55",
    d: "M110.884 263.884H105.642",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 57",
    d: "M453.407 431.648C457.267 431.648 460.398 434.778 460.398 438.64C460.398 442.499 457.267 445.629 453.407 445.629C449.547 445.629 446.417 442.499 446.417 438.64",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.612 365.242C490.849 363.902 497.342 358.656 498.846 353.01C500.208 358 505.922 363.902 511.078 364.35C505.275 366.433 499.726 372.618 498.846 377.476C498.246 372.524 490.573 365.964 486.612 365.242Z",
    fill: "#EBECEF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9678 429.028C50.087 428.359 53.3332 425.734 54.0851 422.912C54.7662 425.407 57.6218 428.359 60.2008 428.583C57.2985 429.623 54.5242 432.715 54.0851 435.145C53.7844 432.67 49.9487 429.389 47.9678 429.028Z",
    fill: "#EBECEF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4141 197.477C86.4141 200.374 84.0664 202.72 81.1714 202.72C78.2748 202.72 75.9287 200.374 75.9287 197.477C75.9287 194.58 78.2748 192.234 81.1714 192.234C84.0664 192.234 86.4141 194.58 86.4141 197.477Z",
    fill: "#D1D9E0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M589.72 186.989C589.72 190.852 586.591 193.981 582.73 193.981C578.868 193.981 575.739 190.852 575.739 186.989C575.739 183.129 578.868 180 582.73 180C586.591 180 589.72 183.129 589.72 186.989Z",
    fill: "#EBECEF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 73",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.775 160.774C187.775 163.671 185.428 166.017 182.533 166.017C179.636 166.017 177.29 163.671 177.29 160.774C177.29 157.877 179.636 155.531 182.533 155.531C185.428 155.531 187.775 157.877 187.775 160.774Z",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Stroke 75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.375 492.356C102.767 493.728 98.7312 491.917 97.3588 488.309C95.9846 484.702 97.798 480.666 101.405 479.293C105.013 477.919 109.049 479.733 110.421 483.34C111.794 486.947 109.982 490.984 106.375 492.356Z",
    stroke: "#D2D8DF",
    strokeWidth: 1.70155,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_13283",
    x1: 401.286,
    y1: 348.563,
    x2: 358.258,
    y2: 429.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPurchaseHistory);
export default __webpack_public_path__ + "static/media/empty-purchase-history.35d041359dc3ed7a752d457718d34239.svg";
export { ForwardRef as ReactComponent };